import NotificationRepository from "../../ports/notificationRepository";

export type fetchNotificationsCountUseCase = (
  isAdmin?: boolean,
  where?: [
    string, 
    "<" | "<=" | "==" | ">=" | ">" | "!=" | "in", 
    string | number | boolean | null | Date | Array<any>
  ][],
  startAfter?: unknown,
  limit?: number
) => Promise<any>;

export const buildFetchNotificationsCount = (dependencies: {
  notificationRepo: NotificationRepository;
}): fetchNotificationsCountUseCase => {
  const { notificationRepo } = dependencies;

  const fetchNotificationsCount = async (
    isAdmin?: boolean,
    where?: [
      string,
      "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
      string | number | boolean | null | Date | Array<any>
    ][],
    startAfter?: unknown,
    limit?: number
  ) => notificationRepo.fetchNotificationsCount(isAdmin, where, startAfter, limit);

  return fetchNotificationsCount;
}